import { memo } from 'react';
import { getFullUrl } from 'hubspot-url-utils';
import { getCRMObjectId } from '../call-message/operators/callMessageGetters';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UILink from 'UIComponents/link/UILink';
import PortalIdParser from 'PortalIdParser';
import CallMessagePropType from '../operators/CallMessagePropType';
import { jsx as _jsx } from "react/jsx-runtime";
function ReviewCallRecord({
  callMessage
}) {
  const crmObjectId = getCRMObjectId(callMessage);
  const portalId = PortalIdParser.get();
  const callReviewPageUrl = `${getFullUrl('app')}/calls/${portalId}/review/${crmObjectId}`;
  return crmObjectId ? /*#__PURE__*/_jsx("div", {
    className: "m-top-2 m-bottom-3",
    children: /*#__PURE__*/_jsx(UILink, {
      external: true,
      href: callReviewPageUrl,
      "data-test-id": "call-review-page-url",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "conversations-calling-message.timeline-call-metadata.call-review"
      })
    })
  }) : null;
}
ReviewCallRecord.propTypes = {
  callMessage: CallMessagePropType.isRequired
};
export default /*#__PURE__*/memo(ReviewCallRecord);